<template>
    <RichResponseButton
        :title="'Schichtzeiten überprüfen und anpassen...'"
        @click="() => showModal = true"
    />
    <Modal v-model="showModal" title="Schichtzeiten anpassen">
        <AvailabilityShiftDefaultsEditor
            :availability-shift-defaults="availabilityShiftDefaults"
            v-on:update:available-shift-default="onUpdateAvailabilityShiftDefaults"
        />
    </Modal>
</template>

<script setup lang="ts">
import {ref} from "vue";
import RichResponseButton from "@/views/Chat/RichResponses/components/RichResponseButton.vue";
import Modal from "@/components/Modal.vue";
import AvailabilityShiftDefaultsEditor from "@/views/Settings/components/AvailabilityShiftDefaultsEditor.vue";
import {getAvailabilityShiftDefaults, saveAvailabilityShiftDefault} from "@/helper/availabilityShiftDefault";
import {AvailabilityShiftDefault} from "@/graphql/generated/graphql";
import {DataLoader} from "@/helper/dataLoader";
import {orderedShiftTypes} from "@/helper/shiftTypes";

const showModal = ref(true)
const availabilityShiftDefaults = ref<AvailabilityShiftDefault[]>([])

function sortByShiftTypeOrder(
    defaults: AvailabilityShiftDefault[]
): AvailabilityShiftDefault[] {
    return [...defaults].sort((a, b) => {
        const idxA = orderedShiftTypes.indexOf(a.type)
        const idxB = orderedShiftTypes.indexOf(b.type)
        return idxA - idxB
    })
}

const loader = new DataLoader([
    async () => {
        availabilityShiftDefaults.value = sortByShiftTypeOrder(await getAvailabilityShiftDefaults())
        // save initial set of shift defaults for this user
        availabilityShiftDefaults.value.forEach(s => {
            saveAvailabilityShiftDefault(s)
        })
    }
]);

const onUpdateAvailabilityShiftDefaults = (newShiftDefault: AvailabilityShiftDefault) => {
    const existingAvailabilityShiftDefault = availabilityShiftDefaults.value.find(s => s.type === newShiftDefault.type)
    if(!existingAvailabilityShiftDefault){
        availabilityShiftDefaults.value.push(newShiftDefault)
        saveAvailabilityShiftDefault(newShiftDefault)
    }else{
        existingAvailabilityShiftDefault.begin = newShiftDefault.begin
        existingAvailabilityShiftDefault.until = newShiftDefault.until
        saveAvailabilityShiftDefault(existingAvailabilityShiftDefault)
    }

}

loader.load()
</script>
